import create from 'zustand'

import { StatusTypes, StatusErrorTypes } from 'types/status'
import { MerchantHistoriesDataTypes } from 'types/merchantHistories'

interface HistoryStoreTypes {
  historyModErrors: StatusErrorTypes
  historyModErrorsSet: (historyModErrors: StatusErrorTypes) => void
  historyModStatus: StatusTypes
  historyModStatusSet: (historyStatus: StatusTypes) => void
  histories: MerchantHistoriesDataTypes[]
  historySet: (histories: MerchantHistoriesDataTypes[]) => void
  historyLookup: MerchantHistoriesDataTypes[]
  historyLookupSet: (histories: MerchantHistoriesDataTypes[]) => void
}

export const useHistoryStore = create<HistoryStoreTypes>((set) => ({
  historyModErrors: '',
  historyModErrorsSet: (historyModErrors) => {
    set({
      historyModErrors,
    })
  },
  historyModStatus: 'idle',
  historyModStatusSet: (historyModStatus) => {
    set({
      historyModStatus,
    })
  },
  histories: [],
  historySet: (histories) => {
    set({
      histories,
    })
  },
  historyLookup: [],
  historyLookupSet: (historyLookup) => {
    set({
      historyLookup,
    })
  },
}))

interface HistoryLookupStoreTypes {
  historyLookupModErrors: StatusErrorTypes
  historyLookupModErrorsSet: (historyLookupModErrors: StatusErrorTypes) => void
  historyLookupModStatus: StatusTypes
  historyLookupModStatusSet: (historyLookupStatus: StatusTypes) => void
  historyLookup: MerchantHistoriesDataTypes[]
  historyLookupSet: (historyLookup: MerchantHistoriesDataTypes[]) => void
}

export const useHistoryLookupStore = create<HistoryLookupStoreTypes>((set) => ({
  historyLookupModErrors: '',
  historyLookupModErrorsSet: (historyLookupModErrors) => {
    set({
      historyLookupModErrors,
    })
  },
  historyLookupModStatus: 'idle',
  historyLookupModStatusSet: (historyLookupModStatus) => {
    set({
      historyLookupModStatus,
    })
  },
  historyLookup: [],
  historyLookupSet: (historyLookup) => {
    set({
      historyLookup,
    })
  },
}))
